import React, { useContext, useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import Home from "./Home";
// import Brands from "./Brands";
import BrandHome from "./Brands/BrandHome";
import { InterestContext } from "./Context"; // Import UserAuth and InterestContext from Context.js
import AllProducts from "./AllProducts";
import ShoppingLists from "./ShoppingLists";
import SharedShoppingLists from "./components/SharedShoppingLists";
//Dynamic Routing For search Results :
import SearchResults from "./SearchResults/SearchResults";

import ProductDetails from "./ProductDetails";
import CollumnPage from "./Experiments/CollumnPage";
// import SearchUsers from "./Header/SearchUsers";
import TestMasonry from "./Experiments/TestMasonry/TestMasonry";
import TestMasonryOld from "./Experiments/oldTestMasonry/TestMasonry";
import InvitedList from "./OldShoppingList/InvitedList";
import NewsFeed5 from "./NewsFeed/NewsFeed5";

import Users from "./SearchResults/Users";
import Products from "./SearchResults/Products";
import PostDetails from "./NewsFeed/PostDetails";
import Chat from "./Chat/Chat";
import Blog from "./Blog/Blog";
import BlogDetails from "./Blog/BlogDetails";
import NewsFeed4 from "./NewsFeed/NewsFeed4";
import CustomFeed from "./NewsFeed/CustomFeed";
import NewsFeed6 from "./NewsFeed/NewsFeed6";
import NewsFeed9 from "./NewsFeed/NewsFeed9";
import Cart from "./Cart/Cart";
import Shipping from "./Shipping/Shipping";
import AllNotifications from "./Notifications/AllNotifications/AllNotifications";
import TestGlight from "./Experiments/TestGlight/TestGlight";
import BrandHome2 from "./Brands/BrandHome2";
import BrandHome3 from "./Brands/BrandHome3";
import Chat2 from "./Chat/Chat";
import Category from "./Category";
import ShoppingLists2 from "./ShoppingLists2";
import ShoppingLists3 from "./ShoppingLists3";
import ChatMobile from "./Chat/ChatMobile";
import useThemeState from "./StatesStore/Theme";
import StreamFeed from "./NewsFeed/StreamFeed";
import DiscoverMasonry from "./NewsFeed/DiscoverMasonry";
import SnapScroll from "./Experiments/SnapScroll";
import Discover2 from "./Discover/Discover2";
import ImagePopup from "./Discover/ImagePopup";
import SimilarProducts from "./Products/SimilarProducts";
import ShoppingLists4 from "./ShoppingLists4";
import { ErrorBoundary } from "react-error-boundary";
import PostedList from "./Posts/PostedList";
import TestUrl from "./Experiments/TestUrl";
import RedirectPage from "./RedirectPage";


function Main() {
  const { interestedProducts, setInterestedProducts } = useContext(
    InterestContext
  );
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  // const { theme, setTheme } = useThemeState();

  // useEffect(() => {
  //   console.log("theme null");
  //   setTheme(document.documentElement.getAttribute("data-bs-theme").toString());
  // }, []);
  // useEffect(() => {
  //   console.log(
  //     "theme1",
  //     document.documentElement.getAttribute("data-bs-theme").toString()
  //   );
  //   console.log("theme2", theme);
  // }, [theme]);
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {/*Disabling Side bar when User is in userInfo Route*/}
      {/* temporarily disabled side nav */}
      {/* {location.pathname === "/" ? "" :{/* <SideNavUserProfile /> */}
      <InterestContext.Provider
        value={{ interestedProducts, setInterestedProducts }}
      >
        <Routes>
          <Route path="/testMasonry" element={<TestMasonry />} />
          <Route path="/testMasonry2" element={<DiscoverMasonry />} />
          <Route path="/testMasonryOld" element={<TestMasonryOld />} />
          <Route path="/testUrl" element={<TestUrl />} />
          <Route path="/product/:id" element={<SimilarProducts />} />
          <Route path="/ImagePopup" element={<ImagePopup />} />
          <Route path="/SnapScroll" element={<SnapScroll />} />
          <Route path="/NewsFeed" element={<NewsFeed5 />} />
          <Route path="/NewsFeed2" element={<NewsFeed4 columns={2} />} />
          <Route path="/NewsFeed3" element={<NewsFeed4 columns={3} />} />
          <Route path="/NewsFeed6" element={<NewsFeed6 />} />
          {/* <Route path="/discover" element={<NewsFeed9 />} /> */}
          <Route path="/discover" element={<Discover2 />} />
          <Route path="/discover2" element={<Discover2 />} />
          <Route path="/StreamFeed" element={<StreamFeed columns={5} />} />
          <Route path="/testglight" element={<TestGlight />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/Shipping" element={<Shipping />} />
          {/* <Route path="/:subSubCategory" element={<CustomFeed />} /> */}
          <Route path="/InvitedList" element={<InvitedList />} />
          <Route path="/" element={<Home />} />
          {/* <Route path="/ProductDetails/:id" element={<ProductDetails />} /> */}
          <Route path="/ProductDetails/:id" element={<SimilarProducts />} />
          <Route path="/post/:id" element={<PostDetails />} />
          <Route path="/postedlist/:id" element={<PostedList />} />

          {/* <Route path="/UserInfo" element={<MoreQuestions />} /> */}
          <Route path="/test" element={<CollumnPage />} />
          {!isSmallScreen && (
            <Route path="/notifications" element={<AllNotifications />} />
          )}
          {/* <Route path="/chat/:chatId?" element={<Chat />} /> */}
          <Route
            path="/chat/:chatId?/:type?"
            element={isSmallScreen ? <ChatMobile /> : <Chat2 />}
          />
          {/* <Route path="/chatMobile" element={<ChatMobile />} /> */}

          <Route path="/blogs" element={<Blog />} />
          <Route path="/blogs/:id" element={<BlogDetails />} />
          <Route
            path="/AllProducts/:gender/:category/:subCategory"
            element={<AllProducts />}
          />
          <Route
            path="/Men"
            element={<Category gender={"male"} fullScreen={true} />}
          />
          <Route
            path="/Women"
            element={<Category gender={"female"} fullScreen={true} />}
          />
          <Route path="/BrandHome/:brandName/" element={<BrandHome3 />} />
          <Route
            path="/BrandHome/:brandName/:category"
            element={<BrandHome3 />}
          />
          <Route
            path="/BrandHome/:brandName/:category/:subCategory/"
            element={<BrandHome3 />}
          />
          <Route
            path="/BrandHome/:brandName/:category/:subCategory/:subSubCategory"
            element={<BrandHome3 />}
          />

          {/* <Route path="/*" element={<Brands />} /> */}
          <Route
            path="/favorites"
            element={<ShoppingLists2 isFavorites={true} />}
          />
          {/* <Route path="/testShoppingLists/*" element={<ShoppingLists2 />} />
          <Route path="/testShoppingLists2/*" element={<ShoppingLists3 />} /> */}
          <Route path="/shoppingLists/*" element={<ShoppingLists4 />} />
          <Route
            path="/shoppingList/:listId/:userId"
            element={<SharedShoppingLists />}
          />
          <Route path="/search/:input" element={<SearchResults />} />
          <Route path="/search/:input/users" element={<Users />} />
          <Route path="/search/:input/products" element={<Products />} />
          <Route path="/:shortId" element={<RedirectPage />} />
          {/* <Route path="/searchuser/:input" element={<SearchUsers />} /> */}
        </Routes>
      </InterestContext.Provider>
    </>
  );
}

export default Main;
